module.exports = {"360427100":"南康镇","360427101":"白鹿镇","360427102":"温泉镇","360427103":"蓼花镇","360427104":"华林镇","360427105":"蛟塘镇","360427106":"横塘镇","360427200":"蓼南乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360427.json
// module id = 1385
// module chunks = 0